import { useState } from "react";
import { useMutation } from "@apollo/client";
import { useAuthContext } from "./useAuthContext";

import { FOLLOW_UNFOLLOW_USER } from "../mutations/userMutations";

export const useFollow = () => {
  const [id, setId] = useState('')
  const [toId, setToId] = useState('')
  const [error, setError] = useState(null)
  const [isLoading, setIsLoading] = useState(null)
  
  const { dispatch } = useAuthContext()

  const [followUnfollowUser] = useMutation(FOLLOW_UNFOLLOW_USER, {
    variables: { id, toId },
    onCompleted: ({ followUnfollowUser }) => {
      dispatch({ type: 'GET_ME', payload: followUnfollowUser })
      setIsLoading(false)
    },
    onError: (error) => {
      setIsLoading(false)
      setError(error.message)
    }
  })

  const followUnfollow = async (id, toId) => {
    setIsLoading(true)
    setError(null)

    await setId(id)
    await setToId(toId)

    if (!id || !toId) {
      setError('Please fill in all fields')
      setIsLoading(false)

      return
    }

    await followUnfollowUser(id, toId)

    setIsLoading(false)
  }

  return { followUnfollow, isLoading, error }
}
